export const WORKDAY_DEPLOYMENT_GUIDE_URL =
  "https://docs.google.com/document/d/e/2PACX-1vQxlYmWqsxobBPdMyzpfNlqqaRyxDce1WhgVksH8QSNLInVqohDYb60c9LInBf-vAQSaJJN8mTSmCYB/pub";
